"use strict";
import { createSlice } from "@reduxjs/toolkit";
export const initialSwapSettingsState = {
  filteredChainIds: void 0
};
export const slice = createSlice({
  name: "swapSettings",
  initialState: initialSwapSettingsState,
  reducers: {
    updateFilteredChainIds: (state, {
      payload: { filteredChainIds }
    }) => {
      state.filteredChainIds = { ...filteredChainIds };
    },
    resetFilteredChainIds: (state) => {
      state.filteredChainIds = void 0;
    }
  }
});
export const { updateFilteredChainIds, resetFilteredChainIds } = slice.actions;
export const { reducer: swapSettingsReducer } = slice;
